import { render, staticRenderFns } from "./DashboardWidget.vue?vue&type=template&id=48b7ac4a&scoped=true&"
import script from "./DashboardWidget.vue?vue&type=script&lang=js&"
export * from "./DashboardWidget.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidget.vue?vue&type=style&index=0&id=48b7ac4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b7ac4a",
  null
  
)

export default component.exports